module.exports = __webpack_public_path__ + "static/full10-45ef198e0764fa71d377fddeff345eca.png";